<template>
  <div class="mt-4">
    <div
      v-for="(tournamentPrize,index) in tournamentPrizes"
      :key="'prizePts_' + tournamentPrize.id"
    >
      <AddTournamentPrizeFormVue
        :index="tournamentPrize.id"
        :place="tournamentPrize.place"
        :amount="tournamentPrize.prize_data?.amount || 0"
        :currency="tournamentPrize.prize_data?.type || 'dollars'"
        :key="'prize_form_' + tournamentPrize.id"
        @update-prize="updatePrize(index, $event)"

      />
    </div>

    <div class="d-flex justify-content-center flex-wrap">
      <button class="btn btn-success mt-4" @click="addTournamentPrize">
        Добавить приз
      </button>
      <button class="btn btn-danger mt-4 ml-2" @click="deleteTournamentPlaces">Удалить приз</button>
    </div>
  </div>
</template>

<script>
import { TournamentAdapterMixin } from "@/mixins/Tournament/TournamentAdapterMixin";
import { TournamentGroupResultAdapterMixin } from "@/mixins/TournamentGroupResult/TournamentGroupResultAdapterMixin";
import { TournamentStandingsAdapterMixin } from "@/mixins/Tournament/TournamentStandingsAdapterMixin";
import AddTournamentPrizeFormVue from "./AddTournamentPrizeForm.vue";

export default {
  name: "AddTournamentPrice",
  components: { AddTournamentPrizeFormVue },
  mixins: [
    TournamentAdapterMixin,
    TournamentGroupResultAdapterMixin,
    TournamentStandingsAdapterMixin,
  ],
  methods: {
    updatePrize(index, updatedData) {
      this.tournamentPrizes[index].prize_data = updatedData;
    },
    deleteTournamentPlaces() {

      if (this.tournamentPrizes.length > 1) {
        this.tournamentPrizes.pop();
      }
    }
  },
  beforeDestroy() {
    this.tournamentPrizes = [];
  },
  created() {
    if (this.$route.name === "tournament_edit") {
      this.getPlacePtsFromGroupResults();
    }

    if (this.$route.name === "create_tournament") {

      this.tournamentPrizes = [
          {
            id: 1,
            place: 1,
            prize_data: {
              amount: 0,
            },
          },
        ];
    }
  },
};
</script>
